import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Grid } from '@material-ui/core'
// import SmartTaskField from 'components/AddOrEditTaskPage/SmartTaskField'
import Name from 'components/AddOrEditTaskPage/Name'
import Automation from 'components/AddOrEditTaskPage/Automation'
import styles from 'components/AddOrEditTaskPage/styles'
import CodeEditor from 'components/TemplateForm/CodeEditor'
import SelectedActionButtons from 'components/AddOrEditTaskPage//SelectedActionButtons'

const inputProps = { style: { padding: '8.5px 14px' } }

export default connect((state) => ({
	value: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
	codeEditorDisplayed: state.email.codeEditorDisplayed,
}))(
	withStyles(styles)(({ value, classes, codeEditorDisplayed }) => (
		<Grid container spacing={16}>
			<Grid item xs={12}>
				{codeEditorDisplayed ? (
					<CodeEditor height="400px" />
				) : (
					<Grid container spacing={16}>
						<Grid item xs={12}>
							<Name inputProps={inputProps} />
						</Grid>
						{/* <SmartTaskField inputProps={inputProps} /> */}
						<Grid item xs={12}>
							<SelectedActionButtons select />
						</Grid>
						<Automation />
					</Grid>
				)}
			</Grid>
		</Grid>
	)),
)
